import { render, staticRenderFns } from "./AssetAllocateList.vue?vue&type=template&id=b5420d1e"
import script from "./AssetAllocateList.vue?vue&type=script&lang=js"
export * from "./AssetAllocateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5420d1e')) {
      api.createRecord('b5420d1e', component.options)
    } else {
      api.reload('b5420d1e', component.options)
    }
    module.hot.accept("./AssetAllocateList.vue?vue&type=template&id=b5420d1e", function () {
      api.rerender('b5420d1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/fixed-asset/AssetAllocateList.vue"
export default component.exports